import React, { useEffect, useState } from "react";
import { Avatar, Box, HStack, Tooltip, useBreakpointValue } from "@chakra-ui/react";
import { fetchItineraryUsers, fetchPackingUsers, fetchBudgetUsers } from "../../api/travelGroupUsers";

const palette = [
  "purple.300",
  "pink.300",
  "purple.400",
  "pink.400",
  "purple.200",
  "pink.200",
];

const TravelGroupCircles = ({
  tripId,
  size = "sm",
  availableResource,
}) => {
  const [users, setUsers] = useState([]);

  const responsiveMax = useBreakpointValue({ base: 4, md: 3, lg: 3, xl: 4 });

  useEffect(() => {
    if (!tripId || !availableResource) return;
    const fetchUsers = async () => {
      try {
        let data;
        if (availableResource === "itinerary") {
          ({ data } = await fetchItineraryUsers(tripId));
        } else if (availableResource === "packing_list") {
          ({ data } = await fetchPackingUsers(tripId));
        } else if (availableResource === "budget_planner") {
          ({ data } = await fetchBudgetUsers(tripId));
        } else {
          setUsers([]);
          return;
        }
        // console.log("TravelGroupCircles", data.data);
        setUsers(data?.data.users || []);
      } catch {
        setUsers([]);
      }
    };
    fetchUsers();
  }, [tripId, availableResource]);

  if (!users.length) return null;

  const shownUsers = users.slice(0, responsiveMax);
  const overflow = users.length - responsiveMax;

  return (
    <HStack spacing={0} position="relative" mr={2}>
      {shownUsers.map((user, idx) => (
        <Tooltip
          key={user.email || idx}
          label={user.username || user.email}
        >
          <Avatar
            name={user.first_name || user.last_name ? `${user.first_name} ${user.last_name}` : user.username || user.email}
            size={size}
            bg={palette[idx % palette.length]}
            position="relative"
            zIndex={shownUsers.length - idx}
            ml={idx !== 0 ? "-10px" : "0"}
            border="2px solid white"
          />
        </Tooltip>
      ))}
      {overflow > 0 && (
        <Box
          as="span"
          display="flex"
          alignItems="center"
          justifyContent="center"
          w={size === "sm" ? 8 : 10}
          h={size === "sm" ? 8 : 10}
          borderRadius="full"
          bg="gray.200"
          border="2px solid white"
          // fontWeight="bold"
          fontSize={size === "sm" ? "md" : "xl"}
          color="black"
          ml="-9px"
          zIndex={0}
        >
          +{overflow}
        </Box>
      )}
    </HStack>
  );
};

export default TravelGroupCircles;
